import React, { useState, useEffect, useRef } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { useDispatch, useSelector } from 'react-redux';
import { getReportBusinessGrapth } from '../../../redux/profile/action';
import ExportButtons from '../ExportButtons';
import { prepareChartData } from '../../../utils/graphUtils';

const BasicChartLineGraphHistory = ({ start_date, end_date, type }) => {
  const dispatch = useDispatch();
  const graphdetails = useSelector(
    ({ profile: { dashboardreportbusinessgraph } }) =>
      dashboardreportbusinessgraph
  );

  const chartRef = useRef(null);
  const [chartData, setChartData] = useState([]);

  // Fetch data
  useEffect(() => {
    if (start_date && end_date && type) {
      dispatch(getReportBusinessGrapth(start_date, end_date, type));
    }
  }, [start_date, end_date, type, dispatch]);

  // Prepare data (✅ use price instead of count)
  useEffect(() => {
    if (Array.isArray(graphdetails?.history) && graphdetails.history.length > 0) {

      const formattedData = prepareChartData(
        graphdetails.history.map(item => ({
          due_date: item.date,
          price: parseFloat(item.price) || 0 // ✅ correct key
        })),
        'price'
      );

      setChartData(formattedData);
    } else {
      setChartData([]);
    }
  }, [graphdetails]);

  return (
    <>
      <ExportButtons
        targetRef={chartRef}
        filename="report_chart_history"
        data={chartData}
      />

      <div ref={chartRef}>
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis
              dataKey="name"
              interval={0}
              textAnchor="end"
              height={80}
            />

            {/* ✅ Format Y-axis as currency */}
            <YAxis tickFormatter={(value) => `$${value}`} />

            {/* ✅ Correct tooltip */}
            <Tooltip
              formatter={(value) => [`$${value}`, 'Price']}
              labelFormatter={(label) => `Date: ${label}`}
            />

            <Legend />

            <Line
              type="monotone"
              dataKey="price" // ✅ fixed
              name="Price"
              stroke="#8884d8"
              strokeWidth={2}
              dot={{ r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default BasicChartLineGraphHistory;